import { createFileRoute } from "@tanstack/react-router";
import { SwitchPersonPage } from "../features/staff/switch-person-page";

export const Route = createFileRoute("/more/switch")({ component: SwitchPersonPage });
